import { Trans } from '@lingui/react'
import { useAtom } from 'jotai'

import type {
  AccountExistsStep,
  EmailPrivacyPolicyStep,
} from '@twisto/api-graphql'
import { TextButton } from '@twisto/components/atoms/button'
import { Link } from '@twisto/components/atoms/link'
import { Typography } from '@twisto/components/atoms/typography'
import { TextField } from '@twisto/components/molecules/text-field'
import { validator } from '@twisto/form'

import { submittingFlowFormAtom } from '../../components'

import * as styles from './email-privacy-policy-step-form.styles'

export const fieldNames = {
  email: 'email',
} as const

export type FormValues = {
  [fieldNames.email]: string
}

type Props = {
  currentStep: Omit<EmailPrivacyPolicyStep | AccountExistsStep, 'id'>
}

export const EmailPrivacyPolicyStepFormContent = ({ currentStep }: Props) => {
  const [submitting] = useAtom(submittingFlowFormAtom)

  const { email, privacyPolicy } = currentStep

  const privacyPolicyPdfUrl = privacyPolicy.url

  return (
    <>
      <div css={styles.emailFieldSection}>
        <TextField
          disabled={submitting}
          helperText={<Trans id="flow.emailFormStep.helperText" />}
          inputProps={{
            autoComplete: 'false',
            autoFocus: true,
          }}
          label={<Trans id="flow.emailFormStep.label" />}
          name={fieldNames.email}
          rules={{
            required:
              email.required && validator.getValidationMessages().required,
            validate: {
              // this returns error message and type of message `isEmail`
              isEmail: validator.formValidators.isEmail,
            },
          }}
          type="email"
          variant="input"
        />
      </div>
      <TextButton fullWidth disabled={submitting} type="submit">
        <Trans id="flow.emailFormStep.submitButton" />
      </TextButton>
      <Typography
        align="center"
        color="textTertiary"
        css={styles.disclaimerSection}
        variant="b3"
      >
        <Trans
          components={[
            <Link
              key="link-to-processing-personal-data"
              href={privacyPolicyPdfUrl}
              target="_blank"
            >
              {null}
            </Link>,
          ]}
          id="flow.emailFormStep.disclaimer"
        />
      </Typography>
    </>
  )
}
